import { ReportsValidationStatus } from '../interfaces';

export const getWarningMessage = ({ loading, status }: { loading: boolean; status: ReportsValidationStatus }) => {
  const { ALLOWED, PENDING_REPORTS_LIMIT_REACHED, REPORTS_LIMIT_REACHED } = ReportsValidationStatus;
  const msg = (limitation: 'active' | 'pending') =>
    // eslint-disable-next-line max-len
    `You reached the limit of the ${limitation} reports and you are unable to create, restore or retry reports. Delete or cancel pending report to bring back reports generation permission.`;

  if (loading) {
    return undefined;
  }

  switch (status) {
    case ALLOWED:
      return undefined;
    case PENDING_REPORTS_LIMIT_REACHED:
      return msg('pending');
    case REPORTS_LIMIT_REACHED:
      return msg('active');
    default:
      return undefined;
  }
};
